export default function FormStep (props) {
  return (
    <div className={classNames(`form-step form-step--${props.name}`, {
      'form-step--disabled': props.isDisabled,
      'form-step--active': props.isActive,
      'form-step--inactive': !props.isActive
    })}>
      <div className="form-step-header" onClick={!props.isDisabled && props.onGoToStepClick}>
        <div className="form-step-title">
          {I18n.t("fe.NewOrderView.step_number", {i: props.i})}: {props.title} {!!props.isLoading && <i className="fa fa-spin fa-circle-o-notch"></i>}
        </div>
        <div className="form-step-go-back-link">(&larr; {I18n.t("papp.common.go_back")})</div>
      </div>

      {!!props.isActive && <div className="form-step-content">
        {props.children}
      </div>}
    </div>
  )
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/FormStep.jsx